export default __webpack_public_path__ + "static/media/placeholder-large-h.6463c590.png";